import { ENV_VARS } from '@/env';
import { Col, Row } from 'antd';
import { t } from 'i18next';
import Button from '../../../components/Buttons/Button';
import FormLabel from '../../../components/Labels/FormLabel';
import SecondaryLabel from '../../../components/Labels/SecondaryLabel';
import Paper from '../../../components/Paper/Paper';

const PortSearchCard = ({ data, handleSelect, isSelected }) => {
  const isHBUser = ENV_VARS.REACT_APP_THEME === 'halliburton';

  return (
    <Paper className="mb-15 py-10 px-15" border>
      <Row gutter={15} align="middle">
        <Col flex={1}>
          <Row gutter={15} align="stretch">
            <Col sm={4}>
              <div className="mb-15">
                <FormLabel>{t('translation:default.fields.portType.label')}</FormLabel>
                <br />
                <SecondaryLabel className="f-14 fw-600">{data?.portType}</SecondaryLabel>
              </div>
              <div>
                <FormLabel>{t('translation:default.fields.portCode.label')}</FormLabel>
                <br />
                <SecondaryLabel className="f-14 fw-600">{data?.portCode}</SecondaryLabel>
              </div>
            </Col>
            <Col sm={8}>
              <div className="mb-15">
                <FormLabel>{t('translation:default.fields.portName.label')}</FormLabel>
                <br />
                <SecondaryLabel className="f-14 fw-600">{data?.portName}</SecondaryLabel>
              </div>
              <div>
                <FormLabel>{t('translation:default.fields.city.label')}</FormLabel>
                <br />
                <SecondaryLabel className="f-14 fw-600">{data?.portCity}</SecondaryLabel>
              </div>
            </Col>
            <Col sm={6}>
              <div className="mb-15">
                <FormLabel>{t('translation:default.fields.stateProvince.label')}</FormLabel>
                <br />
                <SecondaryLabel className="f-14 fw-600">{data?.stateDesc}</SecondaryLabel>
              </div>
              <div>
                <FormLabel>{t('translation:default.fields.postalCode.label')}</FormLabel>
                <br />
                <SecondaryLabel className="f-14 fw-600">{data?.portZip}</SecondaryLabel>
              </div>
            </Col>
            <Col sm={6}>
              <FormLabel>{t('translation:default.fields.country.label')}</FormLabel>
              <br />
              <SecondaryLabel className="f-14 fw-600">{data?.countryName}</SecondaryLabel>
            </Col>
          </Row>
        </Col>
        <Col>
          <Button onClick={() => handleSelect(data)} className={isHBUser ? 'hb-button' : ''} disabled={isSelected}>
            Select
          </Button>
        </Col>
      </Row>
    </Paper>
  );
};

export default PortSearchCard;
